import { render, staticRenderFns } from "./bimImg.vue?vue&type=template&id=6067bd3e&scoped=true&lang=html&"
import script from "./bimImg.vue?vue&type=script&lang=js&"
export * from "./bimImg.vue?vue&type=script&lang=js&"
import style0 from "./bimImg.vue?vue&type=style&index=0&id=6067bd3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067bd3e",
  null
  
)

export default component.exports